import AddressTypes from 'common/Forms/AddressTypes';
import { GetCommonCrsFormWellFormedAddress, GetCommonCrsFormFieldPathValueMap } from 'common/Addresses/AddressFormatters/Shared/AddressFormatHelper';

export function GetFieldPathValueMap(addressProps, wellFormedAddress) {
  switch (addressProps?.addressType) {
    case AddressTypes.Current:
      return GetCommonCrsFormFieldPathValueMap('part1.currentAddress', wellFormedAddress);
    case AddressTypes.Mailing:
      return GetCommonCrsFormFieldPathValueMap('part1.mailingAddress', wellFormedAddress);
    default:
      break;
  }
}

export function GetWellFormedAddress(addressProps, addressValues) {
  switch (addressProps?.addressType) {
    case AddressTypes.Current:
      return GetCommonCrsFormWellFormedAddress(addressValues?.part1?.currentAddress);
    case AddressTypes.Mailing:
      return GetCommonCrsFormWellFormedAddress(addressValues?.part1?.mailingAddress);
    default:
      break;
  }
}
